/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type messaging_ConversationTargetResponse = {
    target_id: string;
    target_type: messaging_ConversationTargetResponse.target_type;
};
export namespace messaging_ConversationTargetResponse {
    export enum target_type {
        GROUP = 'group',
        CHILDCARE = 'childcare',
        OFFICE = 'office',
    }
}

